$(document).ready(function() {

  $('.searchTrigger').click(function(event) {
    $('.searchLink').toggleClass('exp');
    $('.searchLink  input').trigger('focus');
    event.stopPropagation();
    return false;
  });

  $('.searchLink  input').click(function(event) {
    $('.searchLink').addClass('exp');
    
    event.stopPropagation();
  });

    $(document).on("click", function(){
        $('.searchLink').removeClass('exp');
    });


  $('.gridBlockWrap .btnEntry .action').hover(function() {
    var imgAction = $(this).attr('data-img');
    $(this).closest('.gridBlock.large').attr('data-img', imgAction);
  });

  $('.variantDropTrigger').click(function() {
    $(this).closest('.variantDrop ').addClass('exp');
  });

  $('.variantDrop label').click(function() {
    $(this).closest('.variantDrop ').removeClass('exp');
  });

  $('.prodDescBox table').remove();
  var pDescText = $.trim($('.prodDescBox').text());
  if (pDescText == '') {
    $('.prodDescBox').hide();
  }


  $('body').on('click', '.activateSub', function() {
     $(this).closest('[data-subs]').attr('data-subs', true)   
  });

  $('body').on('click', '.closeSubs', function() {
     $(this).closest('[data-subs]').attr('data-subs', false)   
  });
  $('body').on('click', '.subscribeMe', function() {
     $('.completeContactsPurchase ').trigger('click'); 
  });


  $('input[name="subsInterval"]').first().prop('checked', true);
  $('#rc_shipping_interval_frequency').val($('input[name="subsInterval"]:checked').val());

  $('body').on('change', '[name="subsInterval"]', function () {
    $('#rc_shipping_interval_frequency').val($(this).val()).trigger('change');
  });
  
  $('section.booking ul button').click(function (e) {
    $('section.booking  button.active').removeClass('active')
    $(this).parent('button').addClass('active')
  });
  

  jQuery('.location1').hide();
	jQuery('#click-1').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.location1').show();
	});


jQuery('.location2').hide();
	jQuery('#click-2').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.location2').show();
	});


jQuery('.location3').hide();
	jQuery('#click-3').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.location3').show();
       $(window).scrollTop(600)
	});


jQuery('.location4').hide();
	jQuery('#click-4').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.location4').show();
       $(window).scrollTop(600)
	});


jQuery('.location5').hide();
	jQuery('#click-5').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.location5').show();
     $(window).scrollTop(600)
	});


jQuery('.location6').hide();
	jQuery('#click-6').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.location6').show();
       $(window).scrollTop(600)
	});
  
  jQuery('.location7').hide();
	jQuery('#click-7').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.location7').show();
      $(window).scrollTop(600)
	});
  
   jQuery('.location8').hide();
	jQuery('#click-8').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.location8').show();
      $(window).scrollTop(600)
	});

// 	jQuery('.back button').click(function(){
//       jQuery('.main-tb2').hide();
//       jQuery('.main-tb').show();
// 	});
  
//   Second Tab Js Start Here
  
  jQuery('.locations1').hide();
	jQuery('#click2-1').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.locations1').show();
	});

    jQuery('.locations2').hide();
	jQuery('#click2-2').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.locations2').show();
	});

  
  //   Third Tab Js Start Here
  
    jQuery('.locations-1').hide();
	jQuery('#click3-1').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.locations-1').show();
	});
   jQuery('.locations-2').hide();
	jQuery('#click3-2').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.locations-2').show();
	});
   jQuery('.locations-3').hide();
	jQuery('#click3-3').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.locations-3').show();
       $(window).scrollTop(600)
	});
   jQuery('.locations-4').hide();
	jQuery('#click3-4').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.locations-4').show();
       $(window).scrollTop(600)
	});
   jQuery('.locations-5').hide();
	jQuery('#click3-5').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.locations-5').show();
       $(window).scrollTop(600)
	});
   jQuery('.locations-6').hide();
	jQuery('#click3-6').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.locations-6').show();
       $(window).scrollTop(600)
	});
   jQuery('.locations-7').hide();
	jQuery('#click3-7').click(function(){
      jQuery('.main-tb').hide();
      jQuery('.locations-7').show();
       $(window).scrollTop(600)
	});
  
  
  $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.location1').hide();
	});
  
    $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.location2').hide();
	});
  
    $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.location3').hide();
	});
  
    $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.location4').hide();
	});
  
    $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.location5').hide();
	});
  
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.location6').hide();
	});
  
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.location7').hide();
	});
  
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.locations1').hide();
	});
  
    $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.locations2').hide();
	});
   
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.locations-1').hide();
	});
  
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.locations-2').hide();
	});
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.locations-3').hide();
	});
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.locations-4').hide();
	});
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.locations-5').hide();
	});
  
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.locations-6').hide();
	});
   $("ul.nav.nav-tabs button").click(function() {
  	jQuery('.main-tb').show();
     jQuery('.locations-7').hide();
	});
  
  
  
    $(".location1 button.go-back").click(function() {
  	 jQuery('.home').show();
     jQuery('.location1').hide();
      $(window).scrollTop(0)
	});
  
  
    $(".location2 button.go-back").click(function() {
  	 jQuery('.home').show();
     jQuery('.location2').hide();
      
	});
    
  $(".location3 button.go-back").click(function() {
  	 jQuery('.home').show();
     jQuery('.location3').hide();
     $(window).scrollTop(500)
	});
    
  
  $(".location4 button.go-back").click(function() {
  	 jQuery('.home').show();
     jQuery('.location4').hide();
     $(window).scrollTop(500)
	});
    
  
  $(".location5 button.go-back").click(function() {
  	 jQuery('.home').show();
     jQuery('.location5').hide();
     $(window).scrollTop(500)
	});
    
  
  $(".location6 button.go-back").click(function() {
  	 jQuery('.home').show();
     jQuery('.location6').hide();
     $(window).scrollTop(500)
	});
  
   $(".location7 button.go-back").click(function() {
  	 jQuery('.home').show();
     jQuery('.location7').hide();
      $(window).scrollTop(500)
	});
  
//   Tab 2
    
    
 $(".locations1 button.go-back1").click(function() {
  	 jQuery('.menu-1').show();
     jQuery('.locations1').hide();
	});
         
   $(".locations2 button.go-back1").click(function() {
  	 jQuery('.menu-1').show();
     jQuery('.locations2').hide();
	});
         
  //   Tab 3
  
  
   $(".locations-1 button.go-back").click(function() {
  	 jQuery('.menu-2').show();
     jQuery('.locations-1').hide();
      $(window).scrollTop(0)
	});
  
  $(".locations-2 button.go-back").click(function() {
  	 jQuery('.menu-2').show();
     jQuery('.locations-2').hide();
     $(window).scrollTop(0)
	});
  
  $(".locations-3 button.go-back").click(function() {
  	 jQuery('.menu-2').show();
     jQuery('.locations-3').hide();
     $(window).scrollTop(500)
	});
  
  $(".locations-4 button.go-back").click(function() {
  	 jQuery('.menu-2').show();
     jQuery('.locations-4').hide();
    $(window).scrollTop(500)
	});
  
  $(".locations-5 button.go-back").click(function() {
  	 jQuery('.menu-2').show();
     jQuery('.locations-5').hide();
     $(window).scrollTop(500)
	});
  
  $(".locations-6 button.go-back").click(function() {
  	 jQuery('.menu-2').show();
     jQuery('.locations-6').hide();
     $(window).scrollTop(500)
	});
  $(".locations-7 button.go-back").click(function() {
  	 jQuery('.menu-2').show();
     jQuery('.locations-7').hide();
     $(window).scrollTop(500)
	});
  
  
  $('.product-images').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
   arrows: false,
   dots:true
});
  
  });
